import { BusinessUnit, IBusinessUnitInfo } from '../organization/business-unit/business-unit';
import { EntityBase, IEntityBaseInfo } from "../entity/entitybase";
import { Guid } from "../../types/guid.type";

export interface IUnitInfo extends IEntityBaseInfo {
  Code?: string;
  Name?: string;
  Description?: string;
  IsDefault?: boolean;
  AmountMin?: number;
  AmountMax?: number;
  BusinessUnitUid?: Guid;
  BusinessUnit?: IBusinessUnitInfo;
}

export class Unit extends EntityBase {
  Code?: string;
  Name?: string;
  Description?: string;
  IsDefault?: boolean;
  AmountMin?: number;
  AmountMax?: number;
  BusinessUnitUid?: Guid;
  BusinessUnit?: BusinessUnit;

  constructor(info: IUnitInfo) {
    super(info);

    this.Name = info.Name;
    this.Code = info.Code;
    this.Description = info.Description;
    this.IsDefault = info.IsDefault;
    this.AmountMin = info.AmountMin;
    this.AmountMax = info.AmountMax;
    this.BusinessUnitUid = info.BusinessUnitUid;
    this.BusinessUnit = info.BusinessUnit ? new BusinessUnit(info.BusinessUnit) : undefined;
  }

  override title(): string {
    return `Unité : ${this.Name}`;
  }

  override description(): string {
    return `Code : ${this.Code}, Description : ${this.Description}`;
  }
}
